<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-col class="container text-right"> </b-col>

      <b-card class="mt-2 col-12">
        <b-col cols="12">
          <SearchFilter @handleSubmit="searchFilterSubmit" />
        </b-col>
      </b-card>

      <b-card>
        <commonTable
          ref="tableCommon"
          :routeName="$route.name"
          :tableHeader="tableHeader"
          :searchMode="'TrackingNull'"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import * as userData from "@/auth/localStorageUtils.js";
import commonTable from "@/views/Complaint/components/vueGoodTable/commonTable.vue";
import commonTableHeader from "./components/commonTableHeader.js";
import SearchFilter from "./components/SearchFilter.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    BOverlay,
    commonTable,
    SearchFilter,
  },
  data() {
    return {
      showOverlay: false,
      tableHeader: commonTableHeader,
    };
  },
  methods: {
    searchFilterSubmit(params) {
      this.$refs.tableCommon.onSearchSubmit(params);
    },
    getManageGroup(id) {
      const routeData = this.$router.resolve({
        name: "ComplaintManageNullTracking",
        query: { id },
      });
      window.open(routeData.href, "_blank");
    },
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
